import { render, staticRenderFns } from "./OrderBillingDetails.vue?vue&type=template&id=b94404e0&scoped=true&"
import script from "./OrderBillingDetails.vue?vue&type=script&lang=js&"
export * from "./OrderBillingDetails.vue?vue&type=script&lang=js&"
import style0 from "./OrderBillingDetails.vue?vue&type=style&index=0&id=b94404e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94404e0",
  null
  
)

export default component.exports